import { Spinner } from '@latitude/spinner';
import Signup from 'components/porto/Signup';
import dynamic from 'next/dynamic';
import useIsPortoApp from 'utils/useIsPortoApp';

const ModalWithNoSSR = dynamic(() => import('components/porto/StartModal'), {
  ssr: false,
  loading: () => (
    <Spinner className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />
  ),
});

export default function Index() {
  const isPorto = useIsPortoApp();

  return isPorto ? (
    <Signup />
  ) : (
    <ModalWithNoSSR description="" notAllowedRoute />
  );
}
